import { ApiResponse, RequestFailure } from '@owl-nest/api-client'
import * as api from '@owl-nest/api-client/latest'
import { PromiseAction } from '@owl-nest/redux-wrapper'
import { RootState } from '../reducers'

export enum ACTION_TYPE {
  LOAD_CHANNELS_REQUEST = 'LOAD_CHANNELS_REQUEST',
  LOAD_CHANNELS_SUCCESS = 'LOAD_CHANNELS_SUCCESS',
  LOAD_CHANNELS_FAILURE = 'LOAD_CHANNELS_FAILURE',
}

type LoadChannelsFailure = { type: ACTION_TYPE.LOAD_CHANNELS_FAILURE; failure: RequestFailure }
type LoadChannelsRequest = { type: ACTION_TYPE.LOAD_CHANNELS_REQUEST }
type LoadChannelsSuccess = {
  type: ACTION_TYPE.LOAD_CHANNELS_SUCCESS
  success: api.Pageable<api.ChannelList> & { forceClean: boolean }
}

type LoadConfig = { pagination?: string; forceClean?: boolean }

export function loadProjectChannels(
  projectId: number,
  { pagination = undefined, forceClean = false }: LoadConfig = {},
): PromiseAction<RootState, ApiResponse<api.Pageable<api.ChannelList> & { forceClean: boolean }>> {
  const search = new URLSearchParams(pagination)
  search.set('project_id', projectId.toString())

  return {
    types: [ACTION_TYPE.LOAD_CHANNELS_REQUEST, ACTION_TYPE.LOAD_CHANNELS_SUCCESS, ACTION_TYPE.LOAD_CHANNELS_FAILURE],
    promise: async (_, state) => {
      const response = await api.api.get.channels({
        urlParams: { projectId: projectId.toString() },
        getParams: search,
        withToken: state.user.identity.type === 'loggedin',
      })
      return response.next(success => ({ ...success.body, forceClean }))
    },
  }
}

export type ChannelAction = LoadChannelsRequest | LoadChannelsSuccess | LoadChannelsFailure
